import React, { Component } from "react";
import styles from "./Components.local.scss";
import { ICONS, SvgIcon } from "../../Common/Icons";

class ComponentActions extends Component {
  render() {
    const { componentCase } = this.props;
    return (
      <div>
        <span
          className={styles.component_remove}
          onClick={() => this.props.removeComponent(componentCase)}
        >
          <div className={styles.delete}>
            {" "}
            <SvgIcon icon={ICONS.Garbage} className={""} />
          </div>
        </span>
        <span
          style={{ marginTop: "50px" }}
          className={styles.component_remove}
          onClick={() =>
            this.props.updateComponent(
              componentCase,
              this.props.sideBar,
              this.props.component
            )
          }
        >
          <div className={styles.update}>
            <SvgIcon icon={ICONS.EDIT_ICON} className={""} />
          </div>
        </span>
      </div>
    );
  }
}

export default ComponentActions;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/ComponentActions.js